<template>
  <div class="new-se-dialog">
    <v-dialog width="400px" title="Add New HCP" :visible.sync="dialogVisible" :scrollbar="false" @open="onOpen"
      @close="onClose">
      <el-form ref="form" :model="form" :rules="formRules" label-position="top">
        <el-form-item prop="type" label="Type">
          <el-select v-model="form.type" filterable placeholder="Please select type" :disabled="disabledType"
            @change="onTypeChange">
            <el-option v-for="(item, i) in typeList" :key="i" :value="item.TypeID" :label="item.TypeDesc" />
          </el-select>
        </el-form-item>
        <el-form-item prop="mlId" :label="(typeIsVCE || isVMSL) ? 'vMSL' : 'MSL'">
          <el-select v-model="form.mlId" filterable @change="onMlChange"
            :placeholder="(typeIsVCE || isVMSL) ? 'Please select MSL' : 'Please select vMSL'"
            :disabled="isMSL || type == 'here' || isVMSL">
            <el-option v-for="(item, i) in mlList" :key="i" :value="item.value" :label="item.label" />
          </el-select>
        </el-form-item>
        <el-form-item prop="name" label="Name">
          <el-input :disabled="disabled" v-model="form.name" placeholder="Please input name" maxlength="10" />
        </el-form-item>
        <el-form-item prop="province" label="Province" v-if="type != 'here'">
          <!-- <el-input :disabled="disabled && !provinceEmpty" v-model="form.province" placeholder="Please input province"
            maxlength="25" /> -->
          <el-select v-model="form.province" :disabled="disabled && !provinceEmpty" placeholder="Please select province" @change="provinceChange">
            <el-option v-for="(item, i) in provinceList" :key="i" :label="item.province" :value="item.province">
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item prop="city" label="City">
          <el-input v-if="type == 'here'" :disabled="disabled && !cityEmpty" v-model="form.city" placeholder="Please input city"
            maxlength="25" />
          <el-select v-else v-model="form.city" :disabled="disabled && !cityEmpty" placeholder="Please select city" @change="cityChange">
            <el-option v-for="(city, i) in cityList" :key="i" :label="city" :value="city">
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item prop="hospital" label="Hospital / Institution">
          <el-input :disabled="disabled && !hospitalEmpty" v-model="form.hospital"
            placeholder="Please input hospital / institution" maxlength="25" />
        </el-form-item>
        <el-form-item prop="department" label="Department">
          <el-input :disabled="disabled && !departmentEmpty" v-model="form.department"
            placeholder="Please input department" maxlength="25" />
        </el-form-item>
        <el-form-item label="Tag">
          <hcp-tag-select v-model="form.tags" bind-owner :owner-user-id="tagOwnerId" />
        </el-form-item>
        <el-form-item prop="phone" label="Phone">
          <el-input  v-model="form.phone" placeholder="Please input phone" maxlength="20"
            @input="onPhoneInput" />
        </el-form-item>
        <p v-if="admin && type == 'here'" class="text">仅限创建Customer信息</p>
      </el-form>
      <div class="actions">
        <el-button type="primary" @click="onConfirm" :loading="loading">
          Submit{{ loading ? "ting" : "" }}
        </el-button>
        <el-button @click="dialogVisible = false">Cancel</el-button>
      </div>
    </v-dialog>
  </div>
</template>

<script>
import { trimValidate } from "../../utils/validator";
import { RoleCode, HcpType } from '@/utils/role-constant'
import HcpTagSelect from "@/components/hcp-tag-select.vue";

export default {
  name: "NewSEDialog",
  components: {
    HcpTagSelect,
  },
  props: {
    visible: {
      type: Boolean,
      default: false,
      required: true,
    },
    data: Object,
    type: String,
  },
  data() {
    const validatePhone = (rule, value, callback) => {
      const phoneReg = /^1[3|4|5|7|8|9][0-9]{9}$/;
      console.log('admin value:', value, phoneReg.test(value), this.form.phone == "")
      if (phoneReg.test(value) || this.form.phone == "" || this.form.phone == null) {
        callback();
      } else {
        console.log('admin invalid phone')
        callback(new Error("Phone format error, please re-enter"));
      }
      // if (!Number.isInteger(+value)) {
      //   callback(new Error("Phone format error, please re-ente"));
      // } else {
      //   if (phoneReg.test(value) || this.form.phone == "") {
      //     callback();
      //   } else {
      //     callback(new Error("Phone format error, please re-enter"));
      //   }
      // }
    };
    return {
      dialogVisible: this.visible,
      form: {
        mlId: "",
        name: "",
        city: "",
        hospital: "",
        department: "",
        hcpId: "",
        source: "EMSL",
        eaId: "",
        seType: 1,
        type: '',
        phone: '',
        province: '',
        tags: [],
      },
      originalPhone: '',
      cityEmpty: false,
      provinceEmpty: false,
      hospitalEmpty: false,
      departmentEmpty: false,
      formRules: {
        mlId: [
          { required: true, message: "Please select MSL", trigger: "change" },
        ],
        name: [
          {
            required: true,
            validator: trimValidate("Please input name"),
            trigger: "blur",
          },
        ],
        type: [
          { required: true, message: "Please select type", trigger: "change" },
        ],
        city: [
          {
            required: true,
            validator: trimValidate("Please input city"),
            trigger: "blur",
          },
        ],
        province: [
          {
            required: true,
            validator: trimValidate("Please input province"),
            trigger: "blur",
          },
        ],
        hospital: [
          {
            required: true,
            validator: trimValidate("Please input hospital / institution"),
            trigger: "blur",
          },
        ],
        department: [
          {
            required: true,
            validator: trimValidate("Please input department"),
            trigger: "blur",
          },
        ],
        phone: [{ validator: validatePhone, trigger: "change" }],
      },
      mlList: [],
      typeList: [],
      loading: false,
      newSuccessful: false,
      disabledMSL: false,
      typeIsVCE: false,
      disabledPhone: false,
      cityList: [],
    };
  },
  computed: {
    disabled() {
      return this.data !== null;
    },
    isMSL() {
      return this.$store.state.role === 3;
    },
    role() {
      return this.$store.state.role;
    },
    admin() {
      return this.$store.state.role === RoleCode.Admin
    },
    isVMSL() {
      return this.$store.state.role === RoleCode.VMSL
    },
    tagOwnerId() {
      return this.form.mlId && this.form.mlId !== "NA" ? this.form.mlId : "";
    },
    disabledType() {
      return this.isVMSL || this.type == 'here'
    },
    provinceList() {
      return this.$store.state.province
    },
  },
  watch: {
    visible(value) {
      this.dialogVisible = value;
    },
  },
  methods: {
    provinceChange() {
      this.form.city = ''
      this.cityList = this.getCityListByProvince(this.form.province, this.provinceList);
    },
    cityChange() {
      this.updateProvinceByCity(this.form.city);
    },
    updateProvinceByCity(selectedCity) {
      for (const item of this.provinceList) {
        if (item.cities.includes(selectedCity)) {
          this.form.province = item.province;
          return;
        }
      }
      this.form.province = "";
    },
    getCityListByProvince(province, dataList) {
      const provinceData = dataList.find(item => item.province === province);
      return provinceData ? provinceData.cities : [];
    },
    onMlChange() {
      this.form.tags = [];
    },
    onPhoneInput(value) {
      this.form.phone = value.replace(/\D/g, "")
    },
    onTypeChange() {
      this.typeIsVCE = this.form.type == this.typeList.find(item => item.TypeName == HcpType.vCE)?.TypeID
      if (this.typeIsVCE) {
        this.formRules.mlId[0].message = "Please select vMSL"
      } else {
        this.formRules.mlId[0].message = "Please select MSL"
      }
      this.form.mlId = ""
      this.form.tags = []
      this.getMLList()
    },
    async onOpen() {
      this.getMLList();
      await this.getTypeList();
      if (this.data) {
        this.$nextTick(() => {
          if (this.data.source == "EA") {
            this.data.city = this.data.cityMatch;
            //如果ea为空，同步city带入省份
            this.data.province = this.data.provinceMatch;
            this.data.department = this.data.cmdsDepartment;
            this.data.hospital = this.data.cmdsHospital;
            this.disabledPhone = this.data.isPhoneEditable == 0 ? true : false
          }
          if (this.data.source == "CMDS") {
            this.disabledPhone = this.data.isPhoneEditable == 0 ? true : false
          }
          Object.assign(this.form, this.data);
          this.cityEmpty = this.data.source == "EA" ? true : !this.data.city;
          this.provinceEmpty = this.data.source == "EA" ? true : !this.data.province;
          this.hospitalEmpty = !this.data.hospital;
          this.departmentEmpty = !this.data.department;
          if (this.form.province) {
            this.cityList = this.getCityListByProvince(this.form.province, this.provinceList);
          }
          this.originalPhone = this.form.phone
        });
      }else{
        let cityList = [];
        this.provinceList.forEach(item => {
          cityList = cityList.concat(item.cities);
        });
        this.cityList = cityList
      }
      if (this.admin && this.type == 'here') {
        this.form.mlId = "NA"
        this.form.type = this.typeList.length > 0 ? this.typeList.find(item => item.TypeName == HcpType.Customer)?.TypeID : ''
      }
      if (this.isVMSL) {
        this.typeIsVCE = true
        this.form.type = this.typeList.length > 0 ? this.typeList.find(item => item.TypeName == HcpType.vCE)?.TypeID : ''

      }

    },
    onClose() {
      this.form.hcpId = "";
      this.form.source = "EMSL";
      this.form.eaId = "";
      this.form.seType = 1;
      this.$refs.form.resetFields();
      this.$emit("update:data", null);
      this.$emit("update:visible", false);
      this.$emit("closed", this.newSuccessful);
      this.cityEmpty = false;
      this.provinceEmpty = false;
      this.hospitalEmpty = false;
      this.departmentEmpty = false;
      this.newSuccessful = false;
      this.typeIsVCE = false;
      this.disabledPhone = false;
      this.form.tags = [];
    },
    getMLList() {
      let api = "/se/mlList"
      api = this.typeIsVCE || this.isVMSL ? '/se/vmlList' : api
      this.axios.get(api).then(({ code, data }) => {
        if (code === 200) {
          let list =
            this.role == 1 ? [{ UserID: "NA", Name: "NA" }, ...data] : data;
          this.mlList = Array.from(list, (i) => {
            return {
              value: i.UserID,
              label: i.Name,
            };
          });
          if (this.isMSL && data.length > 0) {
            this.form.mlId = data[0].UserID;
          }
          if (this.isVMSL) {
            this.form.mlId = this.$store.state.userInfo.userID
          }
        }
      });
    },
    async getTypeList() {
      await this.axios.get("/se/typeList").then(({ code, data }) => {
        if (code === 200) {
          this.typeList = data
          if (this.admin && this.type != 'here') {
            this.typeList = data.filter(item => item.TypeName != HcpType.Customer)
          }
        }
      });
    },
    matchCity(match1, match2) {
      return match1.includes(match2) || match2.includes(match1);
    },
    onConfirm() {
      this.$refs.form.validate((valid) => {
        if (valid) {
          //如果是import并且来源是ea得判断城市是否匹配
          if (this.data && this.data.source == "EA") {
            if (!this.matchCity(this.form.city, this.form.cityMatch)) {
              this.$alert(
                `This HCP is not existing in CMDS,Can not create HCP by this data.`,
                {
                  type: "warning",
                  confirmButtonText: "OK",
                  callback: () => { },
                }
              );
              return;
            }
            this.form.city = this.form.cityMatch;
            this.form.source = "CMDS";
          }

          this.loading = true;
          let hcpObj = {
            mlId: this.form.mlId === "NA" ? null : this.form.mlId,
            seType: this.form.seType,
            source: this.form.source,
            hcpId: this.form.hcpId,
            eaId: this.form.eaId,
            name: this.form.name.trim(),
            types: [this.form.type],
            city: this.form.city.trim(),
            province: this.form.province.trim()|| null,
            hospital: this.form.hospital.trim(),
            department: this.form.department.trim(),
            unionId: this.form.unionId,
            iDoctorStatus: this.form.iDoctorStatus ? this.form.iDoctorStatus : 0,
            phone : this.form.phone ? this.form.phone.trim() : this.form.phone,
            isPhoneEditable : (this.form.isPhoneEditable == 0 || this.form.isPhoneEditable == 1) ? this.data.isPhoneEditable : 1,
            hasConfirmedPhone : this.form.phone == this.originalPhone?0:1,
            tags: this.form.tags || [],
          }
          this.axios
            .post("/se/create", hcpObj)
            .then(({ code, msg, data }) => {
              this.loading = false;
              if (code === 200) {
                this.newSuccessful = true;
                this.dialogVisible = false;
                this.$message.success("Add HCP successfully");
              } else if (data && data.retry) {
                this.$alert(msg, {
                  type: "warning",
                  confirmButtonText: "OK",
                  callback: () => { },
                });
              } else {
                this.$alert(
                  `${msg}, please do not ${this.data ? "import" : "create"
                  } again.`,
                  {
                    type: "warning",
                    confirmButtonText: "OK",
                    callback: () => { },
                  }
                );
              }
            })
            .catch(() => {
              this.loading = false;
            });
        } else {
          this.loading = false;
          return false;
        }
      });
    },
  },
};
</script>

<style lang="scss" scoped>
.el-form {
  .el-form-item {
    margin-bottom: 10px;
  }

  ::v-deep {
    .el-form-item__label {
      padding: 0 !important;
    }
  }

  .el-input,
  .el-select {
    width: 100%;
  }
}

.actions {
  margin-top: 20px;
  text-align: center;
}

::v-deep {
  .el-dialog__header {
    padding-bottom: 0;
  }

  .el-dialog__body {
    padding: 20px 40px 20px;
  }

  .el-dialog__footer {
    padding: 0;
  }
}

.text {
  text-align: center;
  margin-top: 10px;
  color: #8c8c8c;
}
</style>
